import { ReferenceInput, SelectInput, required } from "react-admin";
import { administrationRequests } from "api/administrationApi";
import GridItem from "./GridItem";

const InstructionLanguageInput = ({ source = "instructionLanguageId", label = "Език", md = 6 }) => (
  <GridItem md={md}>
    <ReferenceInput
      source={source}
      reference={administrationRequests.getInstructionLanguagesSelect()}
      perPage={1000}
    >
      <SelectInput
        optionText="name"
        label={label}
        fullWidth
        validate={required("Полето е задължително.")}
      />
    </ReferenceInput>
  </GridItem>
);

export default InstructionLanguageInput;
